import useLocalStorageState from 'use-local-storage-state';

import { useCurrentUser } from 'auth/CurrentUserProvider';
import { useDevSandbox } from 'components/DevSandbox/DevSandboxProvider';
import { MerlinMessage } from 'types/edgeFunctions';

export const useMerlinMessages = () => {
  const { id } = useDevSandbox();
  const { screenName } = useCurrentUser();

  const storageKey = `merlin-${screenName}-${id}`;

  const [messages, setMessages] = useLocalStorageState<MerlinMessage[]>(storageKey, {
    defaultValue: [],
  });

  const addMessage = (message: MerlinMessage) => {
    setMessages((prev) => [...prev, message]);
  };

  const updateMessage = (id: string, updates: Partial<MerlinMessage>) => {
    setMessages((prev) =>
      prev.map((msg) => (msg.id === id ? { ...msg, ...updates } : msg))
    );
  };

  const deleteMessage = (id: string) => {
    setMessages((prev) => prev.filter((msg) => msg.id !== id));
  };

  const clearMessages = () => {
    setMessages([]);
  };

  return {
    messages,
    lastMessage: messages[messages.length - 1] || null,
    addMessage,
    updateMessage,
    deleteMessage,
    clearMessages,
  };
};
